import React from 'react';
import './IntroAnimation.scss'
export default function IntroAnimation() {
    return (
        <div id="container" className="bouncy-ball intro-animation-container">
            <div className="netflixintro" letter="P">
                <div className="helper-1">
                    <div className="effect-brush">
                        <span className="fur-31"></span>
                        <span className="fur-30"></span>
                        <span className="fur-29"></span>
                        <span className="fur-28"></span>
                        <span className="fur-27"></span>
                        <span className="fur-26"></span>
                        <span className="fur-25"></span>
                        <span className="fur-24"></span>
                        <span className="fur-23"></span>
                        <span className="fur-22"></span>
                        <span className="fur-21"></span>
                        <span className="fur-20"></span>
                        <span className="fur-19"></span>
                        <span className="fur-18"></span>
                        <span className="fur-17"></span>
                        <span className="fur-16"></span>
                        <span className="fur-15"></span>
                        <span className="fur-14"></span>
                        <span className="fur-13"></span>
                        <span className="fur-12"></span>
                        <span className="fur-11"></span>
                        <span className="fur-10"></span>
                        <span className="fur-9"></span>
                        <span className="fur-8"></span>
                        <span className="fur-7"></span>
                        <span className="fur-6"></span>
                        <span className="fur-5"></span>
                        <span className="fur-4"></span>
                        <span className="fur-3"></span>
                        <span className="fur-2"></span>
                        <span className="fur-1"></span>
                    </div>

                    <div className="effect-lumieres">
                        <div className="lamp-1"></div>
                        <div className="lamp-2"></div>
                        <div className="lamp-3"></div>
                        <div className="lamp-4"></div>
                        <div className="lamp-5"></div>
                        <div className="lamp-6"></div>
                        <div className="lamp-7"></div>
                        <div className="lamp-8"></div>
                        <div className="lamp-9"></div>
                        <div className="lamp-10"></div>
                        <div className="lamp-11"></div>
                        <div className="lamp-12"></div>
                        <div className="lamp-13"></div>
                        <div className="lamp-14"></div>
                        <div className="lamp-15"></div>
                        <div className="lamp-16"></div>
                        <div className="lamp-17"></div>
                        <div className="lamp-18"></div>
                        <div className="lamp-19"></div>
                        <div className="lamp-20"></div>
                        <div className="lamp-21"></div>
                        <div className="lamp-22"></div>
                        <div className="lamp-23"></div>
                        <div className="lamp-24"></div>
                        <div className="lamp-25"></div>
                        <div className="lamp-26"></div>
                        <div className="lamp-27"></div>
                        <div className="lamp-28"></div>
                    </div>
                </div>

                <div className="helper-2">
                    <div className="effect-brush">
                        <div className="fur-31"></div>
                        <div className="fur-30"></div>
                        <div className="fur-29"></div>
                        <div className="fur-28"></div>
                        <div className="fur-27"></div>
                        <div className="fur-26"></div>
                        <div className="fur-25"></div>
                        <div className="fur-24"></div>
                        <div className="fur-23"></div>
                        <div className="fur-22"></div>
                        <div className="fur-21"></div>
                        <div className="fur-20"></div>
                        <div className="fur-19"></div>
                        <div className="fur-18"></div>
                        <div className="fur-17"></div>
                        <div className="fur-16"></div>
                        <div className="fur-15"></div>
                        <div className="fur-14"></div>
                        <div className="fur-13"></div>
                        <div className="fur-12"></div>
                        <div className="fur-11"></div>
                        <div className="fur-10"></div>
                        <div className="fur-9"></div>
                        <div className="fur-8"></div>
                        <div className="fur-7"></div>
                        <div className="fur-6"></div>
                        <div className="fur-5"></div>
                        <div className="fur-4"></div>
                        <div className="fur-3"></div>
                        <div className="fur-2"></div>
                        <div className="fur-1"></div>
                    </div>
                </div>

                <div className="helper-3">
                    <div className="effect-brush">
                        <div className="fur-31"></div>
                        <div className="fur-30"></div>
                        <div className="fur-29"></div>
                        <div className="fur-28"></div>
                        <div className="fur-27"></div>
                        <div className="fur-26"></div>
                        <div className="fur-25"></div>
                        <div className="fur-24"></div>
                        <div className="fur-23"></div>
                        <div className="fur-22"></div>
                        <div className="fur-21"></div>
                        <div className="fur-20"></div>
                        <div className="fur-19"></div>
                        <div className="fur-18"></div>
                        <div className="fur-17"></div>
                        <div className="fur-16"></div>
                        <div className="fur-15"></div>
                        <div className="fur-14"></div>
                        <div className="fur-13"></div>
                        <div className="fur-12"></div>
                        <div className="fur-11"></div>
                        <div className="fur-10"></div>
                        <div className="fur-9"></div>
                        <div className="fur-8"></div>
                        <div className="fur-7"></div>
                        <div className="fur-6"></div>
                        <div className="fur-5"></div>
                        <div className="fur-4"></div>
                        <div className="fur-3"></div>
                        <div className="fur-2"></div>
                        <div className="fur-1"></div>
                    </div>
                </div>

                <div className="helper-4">
                    <div className="effect-brush">
                        <div className="fur-31"></div>
                        <div className="fur-30"></div>
                        <div className="fur-29"></div>
                        <div className="fur-28"></div>
                        <div className="fur-27"></div>
                        <div className="fur-26"></div>
                        <div className="fur-25"></div>
                        <div className="fur-24"></div>
                        <div className="fur-23"></div>
                        <div className="fur-22"></div>
                        <div className="fur-21"></div>
                        <div className="fur-20"></div>
                        <div className="fur-19"></div>
                        <div className="fur-18"></div>
                        <div className="fur-17"></div>
                        <div className="fur-16"></div>
                        <div className="fur-15"></div>
                        <div className="fur-14"></div>
                        <div className="fur-13"></div>
                        <div className="fur-12"></div>
                        <div className="fur-11"></div>
                        <div className="fur-10"></div>
                        <div className="fur-9"></div>
                        <div className="fur-8"></div>
                        <div className="fur-7"></div>
                        <div className="fur-6"></div>
                        <div className="fur-5"></div>
                        <div className="fur-4"></div>
                        <div className="fur-3"></div>
                        <div className="fur-2"></div>
                        <div className="fur-1"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}